import { render, staticRenderFns } from "./Boards.vue?vue&type=template&id=30b91278&scoped=true&"
import script from "./Boards.vue?vue&type=script&lang=js&"
export * from "./Boards.vue?vue&type=script&lang=js&"
import style0 from "./Boards.vue?vue&type=style&index=0&id=30b91278&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b91278",
  null
  
)

export default component.exports